module.exports = __webpack_public_path__ + "static/media/report.11dc5804.png";